import { CanActivateFn, Router } from '@angular/router';
import { select } from '@ngxs/store';
import { TicketingCartSelectors } from '../ticketing-cart.state';
import { inject } from '@angular/core';

export const ticketingSeatsGuard: CanActivateFn = (route, state) => {
  const seatQuantity = select(TicketingCartSelectors.totalQuantity);
  const router = inject(Router);
  if (seatQuantity() === 0) {
    console.warn(
      'ticketingSeatsGuard: No seats selected, redirecting to event page'
    );
    const { dateTime, eventCode } = route.params;
    router.navigate(['/ticketing', eventCode, dateTime], {
      queryParams: { eventId: route.queryParams['eventId'] },
    });
    return false;
  }
  return true;
};
